import { IBusinessSignupOperationAnswer } from '@/models/business';
import {
  ECountries,
  IInternationalization,
  TWISM_COUNTRIES_LOCAL_STORAGE_KEY
} from '@/models/internationalization';

interface ISignupSession {
  country?: ECountries;
  countryIso2?: string;
  internationalization?: IInternationalization;
  operation?: string;
  name?: string;
  address?: string;
  ein?: string;
  addressAdditional?: string;
  type?: string;
  city?: string;
  state?: string;
  zip?: string;
  phone?: string;
  website?: string;
  operationAnswers?: IBusinessSignupOperationAnswer[];
}

const initialData: ISignupSession = {};

export function setSessionSignup(data: ISignupSession) {
  const previousData = sessionStorage.getItem('@twism:signup-data');

  let formattedData: ISignupSession = previousData
    ? JSON.parse(previousData)
    : initialData;

  const sessionCountries = sessionStorage.getItem(
    TWISM_COUNTRIES_LOCAL_STORAGE_KEY
  );

  if (sessionCountries) {
    const countries: IInternationalization[] = JSON.parse(sessionCountries);

    if (data.countryIso2) {
      formattedData.internationalization = countries.find(
        country => country.countryIso2 === data.countryIso2
      );
    } else if (data.country) {
      formattedData.internationalization = countries.find(
        country => country.name === data.country
      );
    }
  }

  formattedData = {
    ...formattedData,
    ...data
  };

  sessionStorage.setItem('@twism:signup-data', JSON.stringify(formattedData));
}

export function getSessionSignup() {
  const stringifiedData = sessionStorage.getItem('@twism:signup-data');
  return stringifiedData ? JSON.parse(stringifiedData) : initialData;
}

export function clearSessionSignup() {
  return sessionStorage.removeItem('@twism:signup-data');
}
